import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import {FormattedDate} from 'react-intl';
import ShowOptionalField from '../ShowOptionalField'
import ShowOptionalLabel from '../ShowOptionalLabel'
import ShowLocalNumber from '../ShowLocalNumber'
import ModalConfirm from '../ModalConfirm'
import {copiaTestoNegliAppunti, getStatoGaraDescription} from "../../Helpers";
import ModalGareDocumentCreator from './ModalGareDocumentCreator';
import {client} from '../../Client';
import LocalDate from "../LocalDate";
import LocalTime from "../LocalTime";

class GareTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onCopyToClipboard(value){
        copiaTestoNegliAppunti(value);
    }

    render() {
        let c = this.props.gara;
        let lastIdGara = this.props.lastIdGara;

        let copyBtn = null;
        // if (c.pathLocale){
        //     copyBtn = <a className="ui blue icon button" onClick={() => this.onCopyToClipboard(client.adaptClientPath(c.pathLocale))} title="Copia il path locale della gara sugli appunti">
        //         <i className="copy icon"></i></a>
        // }
        // else {
        //     copyBtn = <a className="ui gray icon button disabled"  title="Path locale non impostato">
        //         <i className="copy icon"></i></a>
        // }

        let editBtn = null;
        if (this.props.readOnly == false){
            editBtn =(
                <Link  className="ui blue icon button" to={`/app/gare/edit/${c.idGara}`}>
                    <i
                        className="edit icon"

                    ></i>
                </Link>
            );
        }

        let inCommessaLink = null;
        let nuovaCommessaBtn = null;
        if(c.idCommessa){
            if (client.getCurrentUser().isrolecommesse) {
                inCommessaLink = (<label className="ui green rounded label"><Link to={`/app/commesse/edit/${c.idCommessa}`}>SI</Link></label>);
            }else{
                inCommessaLink= (<label className="ui green rounded label">SI</label>)
            }
        }else{
            inCommessaLink= (<label className="ui red rounded label">NO</label>)
            if (client.getCurrentUser().isrolecommesse && client.getCurrentUser().isrolecommessew ) {
                nuovaCommessaBtn = (<Link className="ui blue tiny icon button"
                                          to={{pathname: '/app/commesse/new', state: {idGara: c.idGara}}}>
                    <i
                        className="add icon"

                    ></i>Nuova commessa
                </Link>)
            }
        }

        let linkToCreaDoc = null;
        if (c.ragioneSociale && client.getCurrentUser().isroledocumentiw){
            linkToCreaDoc = (
                <ModalGareDocumentCreator
                    title={"Creazione Documento " + c.nomeCompleto}
                    gara={c}
                >
                    <a href={"#"}>Crea documento</a>
                </ModalGareDocumentCreator>
            )
        }
        let deleteButton = null;
        if (this.props.readOnly == false && c.idGara == lastIdGara) {
            deleteButton = (<ModalConfirm
                msg={"Stai per cancellare la gara: " + c.nomeCompleto + "."}
                msgDescription={(<h3>Verrà <span>cancellata</span> la cartella della Gara/Offerta con <span>tutta la struttura sottostante ed anche gli eventuali file presenti</span>.</h3>)}
                onClickOk={(ev) => (this.props.onDeleteItem(ev, c))}
            >
                <a className="ui red icon button"><i className="trash icon"/></a>
            </ModalConfirm>);
        }

        return (
            <tr>
                <td className="collapsing"><Link to={`/app/gare/edit/${c.idGara}`}>{c.codice}</Link></td>
                <td className="collapsing"><Link to={`/app/gare/edit/${c.idGara}`}>{c.anno}</Link></td>
                <td className="sorted descending"><Link to={`/app/gare/edit/${c.idGara}`}>{c.nome}</Link>

                    <div className="sub header">
                        {
                            c.note ? <div className="content">
                                {c.note}
                            </div> : null
                        }
                        <div className="content">
                            Creato il {c.creatoIl ?  <b><LocalDate data={c.creatoIl } /> <LocalTime data={c.creatoIl } /></b> : <b>?</b>} da <b>{c.creatoDa ? c.creatoDa.username : '?'}</b>&nbsp;
                            Modificato il {c.modificatoIl ?  <b><LocalDate data={c.modificatoIl } /> <LocalTime data={c.modificatoIl } /></b> : <b>?</b>} da <b>{c.modificatoDa ? c.modificatoDa.username : '?'}</b>
                        </div>
                    </div>
                </td>

                <td className="collapsing">
                    <label className="ui gray rounded label" data-tooltip={getStatoGaraDescription(c.statoGara)}>{c.statoGara}</label>
                </td>
                <td className="collapsing center aligned">
                    {c.dataReg != null ?
                    <FormattedDate
                    value={c.dataReg}
                    day="numeric"
                    month="numeric"
                    year="numeric"
                /> : <span></span>
                    }
                </td>
                <td className="collapsing center aligned">
                    {c.presentazione}
                </td>
                <td className="collapsing center aligned">
                    {c.sopralluogo}
                </td>
                <td className="collapsing center aligned">
                    {c.chiarimenti}
                </td>


                <td className="">{c.ragioneSociale}
                <div className="sub header">
                    <div>{c.indirizzo} {c.cap} {c.citta} {c.provincia} {c.stato}
                    <ShowOptionalField label="P.IVA" value={c.piva}/> <ShowOptionalField label="C.Fisc." value={c.cfisc}/></div>
                    <ShowOptionalLabel title="FAX"    value={c.fax} icon="fax" extraClassName="left floated"  />
                    <ShowOptionalLabel title="Tel1"    value={c.telefono1} icon="phone" extraClassName="left floated"  />
                    <ShowOptionalLabel title="Tel2"    value={c.telefono2} icon="phone" extraClassName="left floated"  />
                    <ShowOptionalLabel title="Cellulare"    value={c.cellulare} icon="mobile" extraClassName="left floated"  />
                    <ShowOptionalLabel title="e-mail"    value={c.email} icon="mail" extraClassName="left floated"  />
                    <ShowOptionalLabel title="PEC"    value={c.pec} icon="mail" extraClassName="left floated"  />
                    <ShowOptionalLabel title="Web"    value={c.web} icon="mail" extraClassName="left floated"  />

                </div>
                    {linkToCreaDoc}
                </td>
                <td className="collapsing center aligned">{c.idGara}</td>
                <td className="collapsing center aligned">
                    {inCommessaLink}<br/>
                    {nuovaCommessaBtn}
                </td>
                <td className="collapsing center aligned">{c.tipo? c.tipo.descrizione: "non disp."}</td>
                <td className="collapsing center aligned">{c.partecipato ? <label className="ui green rounded label">SI</label> : <label className="ui red rounded label">NO</label>}</td>
                <td className="collapsing no-print">

                    {copyBtn}

                    {editBtn}
                    {deleteButton}

                </td>
            </tr>)
    }
}

export default GareTableRow;




/** WEBPACK FOOTER **
 ** ./src/components/gare/GareTableRow.js
 **/